<div class="card mb-0">
  <div class="card-header">
    <div class="row align-items-center flex-nowrap">
      <div class="col">
        <div class="row g-2 align-items-center flex-nowrap">
          <div class="col-auto">
            <div class="card-icon">
              <i class="bx bxs-image-alt"></i>
            </div>
          </div>
          <div class="col">
            <h4 class="m-0 text-truncate">Photo Gallery</h4>
          </div>
        </div>
      </div>
      <div class="col text-end lh-1">
        <a [routerLink]="['gallery']" class="text-icon float-end">
          Go to gallery
          <i class="bx bx-chevron-right"></i>
        </a>
      </div>
    </div>
  </div>
  <!-- -->
  <div class="card-body">
    <div class="row row-cols-3 g-2" *ngIf="(collection$ | async)?.length; else empty">
      <ng-container *ngFor="let item of collection$ | async; let i = index">
        <ng-container *ngIf="item.media as media">
          <div class="col">
            <div class="position-relative position-absolute-hover">
              <div class="position-absolute top-0 start-0 end-0" style="z-index: 100">
                <div class="p-2">
                  <div class="row justify-content-end g-2">
                    <div class="col-auto">
                      <button
                        type="button"
                        class="btn btn-primary rounded-circle"
                        (click)="download(item)"
                      >
                        <i class="bx bxs-download"></i>
                      </button>
                    </div>
                    <div class="col-auto">
                      <button
                        type="button"
                        class="btn btn-danger rounded-circle"
                        (click)="delete(item)"
                      >
                        <i class="bx bxs-trash-alt"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="gallery-image">
                <a href="javascript: void(0);" (click)="open(i)">
                  <img
                    [src]="item.media.url"
                    (error)="onImageError($event)"
                    class="img-fluid rounded"
                    alt="Gallery image"
                  />
                </a>
              </div>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </div>
</div>
<ng-template #empty>
  <div class="row">
    <div class="col-12">
      <div role="alert" class="alert alert-info d-flex">
        <i class="bx bxs-info-circle me-2 mt-1"></i>
        <div>
          <h6 class="m-0 fw-bolder">No photos to show.</h6>
          <p class="m-0">You have no photos in your gallery.</p>
        </div>
      </div>
    </div>
  </div>
</ng-template>
